import { render, staticRenderFns } from "./zhaobiao.vue?vue&type=template&id=cdd8d18a&scoped=true&"
import script from "./zhaobiao.vue?vue&type=script&lang=js&"
export * from "./zhaobiao.vue?vue&type=script&lang=js&"
import style0 from "./zhaobiao.vue?vue&type=style&index=0&id=cdd8d18a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd8d18a",
  null
  
)

export default component.exports